import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

export class MensajeInformativoData {
  public funcionCancelar: Function = null;
  public funcionAceptar: Function = null;
  public mensaje: string = null;

  constructor(init?: Partial<MensajeInformativoData>) {
    Object.assign(this, init);
  }
}

@Component({
  selector: 'app-mensaje-informativo-dialog',
  templateUrl: './mensaje-informativo-dialog.component.html',
  styleUrls: ['./mensaje-informativo-dialog.component.css'],
})
export class MensajeInformativoDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}

  hayFuncionAceptar(): boolean {
    return this.data.funcionAceptar ? true : false;
  }

  hayFuncionCancelar(): boolean {
    return this.data.funcionCancelar ? true : false;
  }

  funcionAceptar() {
    if (this.hayFuncionAceptar()) {
      this.data.funcionAceptar();
    }
  }

  funcionCancelar() {
    if (this.data.funcionCancelar) {
      this.data.funcionCancelar();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/shared/dialogs/mensaje-informativo-dialog/mensaje-informativo-dialog.component.ts